import {Component, services, element as $, cookies, loggerService, componentService} from '@contorion/core';
import { IRecommendationService } from '../interfaces/recommendation-service.interface';
import { IUserType } from '../interfaces/user-type.interface';

const DEFAULT_NUMBER_OF_RECOMMENDATIONS: number = 10;
const USER_TYPE: IUserType = {
    b2b: 0,
    b2c: 1,
    firstContact: 2,
};
const TRACKING_USER_ID_COOKIE: string = 'userid';
const CLASS_CONTENT_LOADER = 'js-content-loader';
const CLASS_HIDDEN = 'hidden';
const SELECTOR_CONTENT: string = '.js-recommendation-content';
const SELECTOR_RECOMMENDATIONS_HEADER: string = '.js-product-recommendations-header';

export class RecommendationComponent extends Component {

    private recommendationService: IRecommendationService;

    private get recommendationsHeader(): HTMLElement {
        return <HTMLElement> $(SELECTOR_RECOMMENDATIONS_HEADER);
    }

    private get content(): HTMLElement {
        return <HTMLElement> $(SELECTOR_CONTENT);
    }

    private get customerNumber(): string {
        return cookies.get(TRACKING_USER_ID_COOKIE) || 'non-prod-user';
    }

    private get sku(): string {
        return this.element.dataset.sku;
    }

    private get numberOfRecommendations(): number {
        if (this.element.dataset.numberOfRecommendations === undefined) {
            return DEFAULT_NUMBER_OF_RECOMMENDATIONS;
        }

        return parseInt(this.element.dataset.numberOfRecommendations, 10);
    }

    private get customerThemeType(): number {
        if (this.element.dataset.customerThemeType === 'b2b') {
            return USER_TYPE.b2b;
        } else if (this.element.dataset.customerThemeType === 'b2c') {
            return USER_TYPE.b2c;
        } else {
            return USER_TYPE.firstContact;
        }
    }

    constructor(protected element: HTMLElement) {
        super(element);

        this.init();
    }

    private async init(): Promise<void> {
        this.recommendationService = await services.get('recommendation');

        try {
            const skus : Array<string> = await this.recommendationService.getRecommendedSkus(
                this.sku,
                this.customerNumber,
                this.numberOfRecommendations,
                this.customerThemeType,
                );

            if (skus) {
                this.content.setAttribute('data-skus', skus.join(','));
                this.content.classList.add(CLASS_CONTENT_LOADER);
                componentService.load(this.element);
            }
        } catch (error) {
            this.element.classList.add(CLASS_HIDDEN);
            this.recommendationsHeader.classList.add(CLASS_HIDDEN);

            if (window.contorion && window.contorion.isAdBlockerActive) {
                return;
            }

            loggerService.info(error);
        }
    }
}
